import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";

const ProductDeal = ({ deal, className }) => (
  <div aria-hidden={true} className={classnames(styles.productDeal, className)}>
    {deal}
  </div>
);

ProductDeal.propTypes = {
  deal: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ProductDeal;
